
import { Actions,ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject,of,Subscription } from 'rxjs';
import { catchError,switchMap,tap , map} from 'rxjs/operators';
import { BaseActionTypes } from '../State/actions/base.actions';
import { AppGatewayResponseHasError,AppGatewayService } from './app-gateway.service';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { CustomisationFunction, CustomisationGetFeaturesResponse } from '@dave/types';
import { CustomisationCallFunctionRequest } from '@dave/types/dist/proto/customisation/service';

export enum CustomFunctionsSlug {
    createSharepointCommissionRequestFolder = 'kapl_create_sharepoint_request_folder',
    createSharepointCommissionCentralProjectFilesFolder = 'kapl_create_sharepoint_central_project_files_folder',
    createSharepointCommissionConstructionFilesFolder = 'kapl_create_sharepoint_construction_files_folder',
}

/**
 * List of functions that are used to handle Sharepoint folders representing commissions
 */
export const CUSTOMIZATION_FUNCTIONS_COMMISSION_SHAREPOINT = [
    CustomFunctionsSlug.createSharepointCommissionRequestFolder,
    CustomFunctionsSlug.createSharepointCommissionCentralProjectFilesFolder,
    CustomFunctionsSlug.createSharepointCommissionConstructionFilesFolder,
];

@Injectable({
    providedIn: 'root',
})
export class CustomizationDataService implements OnDestroy {

    private clearSub: Subscription;

    private functionCache$ = new BehaviorSubject<CustomisationFunction[]>(null);
    private featureCache$ = new BehaviorSubject<string[]>(null);

    private actions$ = inject(Actions);
    private store = inject(Store<State>);
    private api = inject(AppGatewayService);
    private toastrService = inject(ToastrService);
    constructor(

    ) {
        this.reset();
        this.clearSub = this.actions$.pipe(ofType(BaseActionTypes.InitStore)).subscribe(() => this.reset());
    }
    ngOnDestroy(): void {
        this.clearSub.unsubscribe();
    }
    private reset() {
        this.functionCache$.next(null)
        this.featureCache$.next(null);
    }

    callFunction$(payload: CustomisationCallFunctionRequest) {
        return this.api.Request$({ CustomisationCallFunction: payload }).pipe(
            tap((response) => {
                if (AppGatewayResponseHasError(response)) {
                    throw new Error('CustomisationCallFunctionRequest failed with errors:' + response.Errors);
                }
            }),
            map((response) => {
                if (response.CustomisationCallFunction.Error) {
                    this.toastrService.error(response.CustomisationCallFunction.Error);
                    return null;
                }
                return response.CustomisationCallFunction.Parameters
            }),
            catchError((err) => {
                this.store.dispatch(BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: 'Funktion fehlgeschlagen', Err: err } }));
                return of(null);
            }),
        );
    }

    getFunctions$(useCache = true) {
        if (this.functionCache$.value && useCache) {
            return this.functionCache$.asObservable();
        }
        return this.api.Request$({ CustomisationGetFunctions: {} }).pipe(
            tap((response) => {
                if (AppGatewayResponseHasError(response)) {
                    throw new Error('CustomisationGetFunctions failed with errors:' + response.Errors);
                }
            }),
            switchMap((response) => {
                if (Object.keys(response?.Errors || {}).length === 0) {
                    this.functionCache$.next(response.CustomisationGetFunctions.Functions);
                    return this.functionCache$.asObservable();
                } else {
                    throw response.Errors;
                }
            }),
            catchError((err) => {
                this.store.dispatch(BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: 'Funktionen abrufen fehlgeschlagen', Err: err } }));
                return of(null);
            }),
        );
    }


    getFeatures$(useCache = true) {
        if (this.featureCache$.value && useCache) {
            return this.featureCache$.asObservable();
        }
        return this.api.Request$({ CustomisationGetFeatures: {} }).pipe(
            tap((response) => {
                if (AppGatewayResponseHasError(response)) {
                    throw new Error('CustomisationGetFeatures failed with errors:' + response.Errors);
                }
            }),
            switchMap((response) => {
                if (Object.keys(response?.Errors || {}).length === 0) {
                    this.featureCache$.next(response.CustomisationGetFeatures.FeatureSlugs);
                    return this.featureCache$.asObservable();
                } else {
                    throw response.Errors;
                }
            }),
            catchError((err) => {
                this.store.dispatch(BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: 'Features abrufen fehlgeschlagen', Err: err } }));
                return of(null);
            }),
        );
    }

}
